import { Input } from 'cd-eft/components/common/Input';
import { observer } from 'mobx-react';
import React, { Fragment, useEffect, useRef } from 'react';
import { FormulaBanner } from '../Common/FormulaBanner';
import {
  InputContainer,
  ResultsContainer,
  DescriptionContainer,
  ImageContainer,
  FormulaPrintModalContainer,
} from '../template/FormulaFormTemplates';
import { PipeDropVM } from './PipeDropVM';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import pdfLogo from 'cd-eft/assets/images/pdf-blue.svg';
import { StageDischargeGraph } from '../Common/StageDischargeGraph';


const PipeDropComponent = (props) => {
  const vm = useRef(new PipeDropVM(props)).current;
  useEffect(() => {
    // on initial render, load form data - desc, img, help link
    vm.getFormData(`${props.section}_${props.title}_${props.id}`);
  }, []);
  return (
    <Fragment>
      <FormulaBanner title={vm.formulaTitle} help={vm.bannerHelpLink} />
      <div className="row formula-content">
        <InputContainer computeCallback={() => { vm.computefnPipeDrop() }} printCallback={() => { vm.launchAndExport() }} isLoading={vm.isLoading} disableCompute={vm.disableComputeBtn} disablePrint={vm.disablePrintBtn || !vm.hasResults} >
          <span className="input-help-header">
            <a href={vm.helpLink} target='_blank' >Help select n value <img src={pdfLogo} alt={'PDF logo'} /></a>
          </span>
          <h2 className='sections-heading'>Earthworks</h2>
          <Input
            label="Top Width (ft)"
            idAndName="top-width"
            valid={!vm.formValidation.topWidth}
            value={vm.pipeDropFormData.earthworksDto.topWidth}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.pipeErrorClass('topWidth')}
          />
          <Input
            label="DS Toe Elevation (ft)"
            idAndName="ds-toe-elev"
            valid={!vm.formValidation.dsToeElev}
            value={vm.pipeDropFormData.earthworksDto.dsToeElev}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.pipeErrorClass('dsToeElev')}
          />
          <Input
            label="Side Slopes Up-stream (ft/ft)"
            idAndName="up-stream"
            valid={!vm.formValidation.upStream}
            value={vm.pipeDropFormData.commonSideSlopeDto.upStream}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.pipeErrorClass('upStream')}
          />
          <Input
            label="Side Slopes Down-stream (ft/ft)"
            idAndName="down-stream"
            valid={!vm.formValidation.downStream}
            value={vm.pipeDropFormData.commonSideSlopeDto.downStream}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.pipeErrorClass('downStream')}
          />
          <h2 className='sections-heading'>Pipe</h2>
          <Input
            label="Manning's n"
            idAndName="mannings-n"
            valid={!vm.formValidation.mannings}
            value={vm.pipeDropFormData.commonPipeDto.mannings}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.0001}
            onKeyDown={vm.handleOnKeyDown}
            min={0.0001}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.pipeErrorClass('mannings')}
          />
          <Input
            label="Pipe Diameter (in)"
            idAndName="pipe-diameter"
            valid={!vm.formValidation.pipeDiameter}
            value={vm.pipeDropFormData.commonPipeDto.pipeDiameter}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onKeyDown={vm.handleOnKeyDown}
            min={0.02}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.pipeErrorClass('pipeDiameter')}
          />
          <Input
            label="Extra Pipe Beyond Toe (ft)"
            idAndName="extra-pipe-beyond-toe"
            valid={!vm.formValidation.extraPipeBeyondToe}
            value={vm.pipeDropFormData.commonPipeDto.extraPipeBeyondToe}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.pipeErrorClass('extraPipeBeyondToe')}
          />
          <Input
            label="Skew Angle&deg;"
            idAndName="skew-angle"
            valid={!vm.formValidation.skewAngle}
            value={vm.pipeDropFormData.commonPipeDto.skewAngle}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.pipeErrorClass('skewAngle')}
          />
          <h2 className='sections-heading'>Elevations</h2>
          <Input
            label="Top Elevation (ft)"
            idAndName="top-elev"
            valid={!vm.formValidation.topElev}
            value={vm.pipeDropFormData.pipeDropElevationDto.topElev}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.pipeErrorClass('topElev')}
          />
          <Input
            label="Auxiliary Spillway Elevation (ft)"
            idAndName="aux-spillway-elev"
            valid={!vm.formValidation.auxSpillwayElev}
            value={vm.pipeDropFormData.pipeDropElevationDto.auxSpillwayElev}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.pipeErrorClass('auxSpillwayElev')}
          />
          <Input
            label="Water Elevation (ft)"
            idAndName="water-elev"
            valid={!vm.formValidation.waterElev}
            value={vm.pipeDropFormData.pipeDropElevationDto.waterElev}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.pipeErrorClass('waterElev')}
          />
          <Input
            label="Riser-Top Elevation (ft)"
            idAndName="riser-top-elev"
            valid={!vm.formValidation.riserTopElev}
            value={vm.pipeDropFormData.pipeDropElevationDto.riserTopElev}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.pipeErrorClass('riserTopElev')}
          />
          <Input
            label="Riser Diameter (in)"
            idAndName="riser-diameter"
            valid={!vm.formValidation.riserDiameter}
            value={vm.pipeDropFormData.pipeDropElevationDto.riserDiameter}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.pipeErrorClass('riserDiameter')}
          />
          <Input
            label="Riser Length Below Inlet (in)"
            idAndName="riser-length-below-inlet"
            valid={!vm.formValidation.riserLengthBelowInlet}
            value={vm.pipeDropFormData.pipeDropElevationDto.riserLengthBelowInlet}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.pipeErrorClass('riserLengthBelowInlet')}
          />
          <Input
            label="Inlet Elevation (ft)"
            idAndName="inlet-elev"
            valid={!vm.formValidation.inletElev}
            value={vm.pipeDropFormData.pipeDropElevationDto.inletElev}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.pipeErrorClass('inletElev')}
          />
          <Input
            label="Outlet Elevation (ft)"
            idAndName="outlet-elev"
            valid={!vm.formValidation.outletElev}
            value={vm.pipeDropFormData.pipeDropElevationDto.outletElev}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onKeyDown={vm.handleOnKeyDown}
            min={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.pipeErrorClass('outletElev')}
          />
          <div className='checkbox-container'>
            <label className='label-formula-checkbox usa-label' htmlFor="enable-trailwater-elev">
              Enable Tailwater
            </label>
            <input
              className="checkbox-input-formulas"
              id="enable-trailwater-elev"
              data-testid="the-Checkbox"
              type="checkbox"
              name="enable-trailwater-elev"
              checked={vm.pipeDropFormData.pipeDropElevationDto.enableTailwater}
              onChange={(e) => {
                vm.toggleEnableTailwater()
              }}
              onBlur={(e) => vm.validateInput('tailwater-elevation', vm.pipeDropFormData.pipeDropElevationDto.tailwaterElev)}
            />
          </div>
          <Input
            label="Tailwater Elevation (ft)"
            idAndName="tailwater-elev"
            valid={!vm.formValidation.tailwaterElev}
            value={vm.pipeDropFormData.pipeDropElevationDto.tailwaterElev}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            onKeyDown={vm.handleOnKeyDown}
            min={0}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            className={vm.pipeErrorClass('tailwaterElev')}
            disabled={!vm.pipeDropFormData.pipeDropElevationDto.enableTailwater}
          />
        </InputContainer>
        <div className="col formula-information">
          {vm.hasResults ? (
            <Fragment>
              <div className="row formula-results">
                <ResultsContainer>
                  <div className="col-auto result-value-group">
                    <div className="row">
                      <div className="col-10 result-label">Capacity (cfs):</div>
                      <div className="col-auto">{vm.calculationResults.capacity}</div>
                    </div>
                    <div className="row">
                      <div className="col-10 result-label">Length of Pipe (ft):</div>
                      <div className="col-auto">{vm.calculationResults.lengthOfPipe}</div>
                    </div>
                    <div className="row">
                      <div className="col-10 result-label">Riser Height Including Seating (ft):</div>
                      <div className="col-auto">{vm.calculationResults.riserHeightIncludingSeating}</div>
                    </div>
                    <div className="row">
                      <div className="col-10 result-label ">Seepage Path (ft):</div>
                      <div className="col-auto">{vm.calculationResults.seepagePath}</div>
                    </div>
                    <div className='row'>
                      <div className="col-4 result-label">Message:</div>
                      <div className="col long-value">{vm.calculationResults.message}</div>
                    </div>
                  </div>
                </ResultsContainer>
              </div>
              {vm.plotData ? <StageDischargeGraph targetDivId={vm.targetDivID} plotData={vm.plotData} windowOptions={vm.windowOptions} forReport={false} /> : null}
            </Fragment>
          ) : null}
          <div className="row formula-description">
            <DescriptionContainer>
              <p>
                {vm.formDescription}
                &nbsp;
                <a target="_blank" href={vm.bannerHelpLink}>
                  Learn More
                  <img src={pdfLogo} alt={'PDF logo'} />
                </a>
              </p>
            </DescriptionContainer>
          </div>
          <div className="row formula-images">
            <ImageContainer>
              <img
                className="pipedrop-img"
                src={vm?.image}
                alt={vm.hydraulicFormulaImageDescription}
                title={vm.formulaTitle}
              />
            </ImageContainer>
          </div>
        </div>
        {vm.isLoading && <Loader message={''} />}
      </div>
      <div>
        <FormulaPrintModalContainer
          vm={vm}
          inputs={vm.exportedInputs}
          results={vm.exportedResults}
          images={[vm.image]}
          formulaName={vm.formulaTitle}
          windowOptions={vm.windowOptionsForPrint}
          stageDischarge={vm.plotData !== undefined ? true : false}// Should be true for this formula. plotData should be propulated in correct format after api results
          stageDischargeData={vm.plotData}
        />
      </div>
    </Fragment>
  );
};

export const PipeDropFormula = observer(PipeDropComponent);
